<div class="sequence-preview">
  <div class="sequence-preview__title-container">
    @for (title of titles; track title; let i = $index) {
      <span class="sequence-preview__title" [ngStyle]="{ left: (i * 100) / titles.length + '%' }">
        {{ title }}
      </span>
    }
    @for (title of titles; track title; let i = $index) {
      <span
        class="sequence-preview__dot"
        [ngStyle]="{ left: (i * 100) / titles.length + '%' }"
      ></span>
    }
  </div>
  <div
    class="sequence-preview__container"
    [ngClass]="{ 'sequence-preview__container--beacon': isBeacon() }"
  >
    @for (segment of offsetSegments; track $index) {
      <span
        class="sequence-preview__offset"
        [ngStyle]="{ left: getPercent(segment.left) + '%', width: getPercent(segment.width) + '%' }"
      ></span>
    }
    @for (fix of fixes; track fix; let i = $index) {
      <span
        class="sequence-preview__fix"
        [ngStyle]="{ left: getPercent(fix) + '%' }"
        [ngClass]="{
          'sequence-preview__fix--skip': skipPosition() && i % (skipPosition() + 1) !== 0,
          'sequence-preview__fix--transmitted': isTransmitted(
            i,
            skipPosition(),
            fixPerTransmission()
          ),
        }"
        [matTooltip]="getGeneralString(fix)"
      ></span>
    }
  </div>
</div>
